import React, { useState } from "react";
import TableCustom from "../../../components/table/tableCustom";
import InputTextField from "../../../components/input/inputTextField";
import { SearchOutlined } from "@mui/icons-material";
import TableRowCommon from "../../../components/table/TableRowCommon";

const ListStudent = ({ dataStudent }: { dataStudent: any[] }) => {
  const [search, setSearch] = useState<string>("");

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");

  const headCells = [
    {
      id: "fullname",
      width: 10,
      disablePadding: true,
      align: "start",
      label: "ชื่อ - นามสกุล",
    },
    {
      id: "nickname",
      disablePadding: true,
      width: 25,
      align: "center",
      label: "ฉายา",
    },
    {
      id: "student_no",
      disablePadding: false,
      align: "center",
      width: 15,
      label: "รหัสประจำตัวนักศึกษา",
    },
  ];

  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const {
      student_frist_name,
      student_last_name,
      student_middle_name,
      student_no,
      id_student,
    } = objData;
    
    const student_first_name = student_frist_name;

    const objRenderData = {
      key: id_student,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "start",
          label: student_first_name + " " + student_last_name,
        },
        {
          option: "TEXT",
          align: "center",
          label: student_middle_name,
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: student_no,
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  return (
    <>
      <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        <article className="w-full col-span-12 lg:col-span-3  md:col-span-3  sm:col-span-3">
          <InputTextField
            startAdornment={<SearchOutlined />}
            placeholder="ค้นหา ชื่อ - นามสกุล/เลขประจำตัว"
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setSearch(e.target.value)
            }
          />
        </article>
      </div>

      <section className="w-full mt-10">
        <TableCustom
          tableMinWidth={1440}
          tableFixedWidth
          customScroll
          page={page}
          pageLimit={pageLimit}
          sortBy={sortBy}
          sortType={sortType}
          headCells={headCells}
          rowCount={totalItems}
          rowsData={
            dataStudent &&
            dataStudent?.filter((x) => {
              if (search) {
                
              }
              return true
            }).map((data: any, i: any) => {
              return renderData(data, i);
            })
          }
          onSort={() => { }}
          setPageLimit={(value: number) => setPageLimit(value)}
          setPage={(value: number) => setPage(value)}
        />
      </section>
    </>
  );
};

export default ListStudent;
